import React, { useState } from 'react'
import { Button, Form, InputNumber, Modal } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { actions } from '../../../../../store/reducers/assignment.reducer'
import { connect } from 'react-redux'
import { useParams } from 'react-router'
import { useAutoFocusFirstInput } from '../../../../../../hooks/useAutoFocusFirstInput'

const EditFileGradingFooter = ({ isWaitingForFileSave }) => {
    return (
        <>
            <Button type='primary' htmlType='submit' form='edit-file' loading={isWaitingForFileSave}>
                Save
            </Button>
        </>
    )
}

const EditFileGradingModal = ({ showEditFileGradingModal, setShowEditFileGradingModal, file, updateFileGrading }) => {
    const { token, layerId } = useParams()
    const [form] = Form.useForm()
    useAutoFocusFirstInput()

    const [isWaitingForFileSave, setIsWaitingForFileSave] = useState(false)

    const handleEditFileGradingModalClose = () => setShowEditFileGradingModal(false)

    const handleSaveFile = async () => {
        setIsWaitingForFileSave(true)
        const updateFileGradingSucceed = await updateFileGrading(
            token,
            layerId,
            file.id,
            form.getFieldValue('feedback'),
            form.getFieldValue('grade'),
        )
        setIsWaitingForFileSave(false)
        if (updateFileGradingSucceed) handleEditFileGradingModalClose()
    }

    return (
        <Modal
            title='Edit file grading'
            open={showEditFileGradingModal}
            footer={<EditFileGradingFooter isWaitingForFileSave={isWaitingForFileSave} />}
            forceRender
            onCancel={handleEditFileGradingModalClose}
        >
            <Form
                name='edit-file'
                onFinish={handleSaveFile}
                form={form}
                autoComplete='off'
                layout='vertical'
                requiredMark={false}
            >
                <Form.Item name='feedback' label='Feedback' initialValue={file.feedback === null ? '' : file.feedback}>
                    <TextArea rows={4} />
                </Form.Item>
                <Form.Item
                    name='grade'
                    label='Grade'
                    initialValue={file.grade === null ? 0 : file.grade}
                    rules={[
                        {
                            type: 'number',
                            min: 0,
                        },
                    ]}
                >
                    <InputNumber addonAfter='%' style={{ width: 120 }} />
                </Form.Item>
            </Form>
        </Modal>
    )
}

const mapDispatch = dispatch => {
    return {
        updateFileGrading: (token, layerId, fileId, feedback, grade) => {
            return dispatch(actions.updateFileGrading(token, layerId, fileId, feedback, grade))
        },
    }
}

export default connect(null, mapDispatch)(EditFileGradingModal)
